export enum StepType {
  ByFoot = "by-foot",
  ByCar = "by-car",
  ByPublicTransport = "by-public-transport",
  ByVehicle = "by-vehicle",
}
